import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { authInterceptor } from '@lib/interceptors/token.interceptor';
import { routes } from './app.routes';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideStore } from '@ngrx/store';
import { appReducers } from '@store/app.state';
import { provideEffects } from '@ngrx/effects';
import { TenantEffects } from '@store/effects/tenant.effects';

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom([BrowserModule, BrowserAnimationsModule, MatDialogModule, MatSnackBarModule, NgbModule]),
        provideRouter(routes, withHashLocation()),
        provideHttpClient(withInterceptors([authInterceptor])),
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { subscriptSizing: 'dynamic' },
        },
        provideStore(appReducers),
        provideEffects([TenantEffects]),
    ],
};
